export default "__VITE_ASSET__POuqkfyf__"